//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    product: { type: String, required: true },
    productDetails: { type: Object, default: () => ({}) },
    isLE: { type: Boolean, required: true }
  },
  data () {
    return {
      activeBestsellerId: 0
    }
  },
  computed: {
    frameType () {
      if (!this.product.includes('-')) return null
      const frameType = this.product.split('-')[1].toLowerCase()
      if (['tf', 'ff'].includes(frameType)) return frameType
      return null
    },
    polarisedState () {
      if (!this.product.includes('-')) return null
      const polarisedState = this.product.split('-')[1].toLowerCase()
      if (['pol', 'nonpol'].includes(polarisedState)) return polarisedState
      return null
    },
    skuField () {
      if (this.isLE || (this.frameType === null && this.polarisedState === null)) return 'sku'
      if (this.frameType !== null) return this.frameType === 'tf' ? 'skuTF' : 'skuFF'
      if (this.polarisedState !== null) return this.polarisedState === 'pol' ? 'skuPol' : 'skuNonPol'
      return 'sku'
    },
    skuPrefix () {
      return this.product.split('-')[0] || ''
    },
    bestsellers () {
      if (this.isLE) return [{ sku: this.product }]
      return [
        ...(this.$store.getters['product/bestsellers'](this.skuPrefix) || []).slice(0, 3),
        {
          sku: 'egiftcard',
          isGiftCard: true
        }
      ]
    },
    activeBestseller () {
      return this.bestsellers[this.activeBestsellerId] || {}
    },
    sku () {
      if (this.isLE) return this.product
      if (!this.bestsellers) return ''
      if (this.activeBestseller.isGiftCard) return this.activeBestseller.sku
      return (this.activeBestseller)[this.skuField]
    },
    productName () {
      if (this.isLE) return this.$store.getters['product/limitedEditionProductName'](this.product)
      return this.$store.getters['product/productName'](this.product)
    },
    price () {
      if (this.isLE) return this.$store.getters['product/limitedEditionPrice'](this.product)
      return this.$store.getters['product/priceFromSku'](this.bestsellers[0][this.skuField])
    },
    giftCardSelected () {
      return this.activeBestseller.isGiftCard
    },
    title () {
      if (this.giftCardSelected) return 'Gift Voucher'
      if (this.productDetails.title) return this.productDetails.title
      
      return this.productName
    }
  },
  methods: {
    async addToCart () {
      await this.$store.dispatch('cart/ADD_BY_SKU', this.sku)
    },
    getSKU (bestseller) {
      if (bestseller.isLE || bestseller.isGiftCard) return bestseller.sku
      return bestseller[this.skuField] || ''
    }
  }
}
